import Entity from "./Entity";

export default class BasicStatistics extends Entity {
    constructor(data) {
        super(data);
    }
}